export const relationFieldsTableHeaderElements = [
  { label: "Nombre", value: "nombre", align: "inherit" },
];
